
export default function ContactCTA() {
  return (
    <section className="bg-white py-10">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <a
          href="#booking-form"
          className="inline-flex items-center gap-2 bg-[#F5A623] hover:bg-[#E09500] text-white font-extrabold py-4 px-10 rounded-lg text-lg transition-colors whitespace-nowrap shadow-lg cursor-pointer"
        >
          <i className="ri-calendar-check-fill"></i>
          Get Your Free Estimate
        </a>
      </div>
    </section>
  );
}
